import { Controller } from "@hotwired/stimulus"

// Reusable toggle for any password input: flips it between masked and revealed
// states while keeping the eye/eye-closed icons and the button's accessible
// state in sync. Wired up via `aqui_input(..., password_toggle: true)`.
export default class extends Controller {
  static targets = ["input", "button", "maskIcon", "revealIcon"]

  connect() {
    if (!this.hasButtonTarget) return

    this.showLabel = this.buttonTarget.getAttribute("aria-label") || "Show password"
    this.hideLabel = this.showLabel.replace(/^Show\b/, "Hide")
  }

  toggle() {
    const reveal = this.inputTarget.type === "password"
    this.inputTarget.type = reveal ? "text" : "password"

    if (this.hasMaskIconTarget) {
      this.maskIconTarget.classList.toggle("hidden", reveal)
    }
    if (this.hasRevealIconTarget) {
      this.revealIconTarget.classList.toggle("hidden", !reveal)
    }
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-pressed", String(reveal))
      this.buttonTarget.setAttribute(
        "aria-label",
        reveal ? this.hideLabel : this.showLabel
      )
    }
  }
}
